import { Button } from "@mantine/core";
import { AuthError } from "@supabase/supabase-js";
import { usePostHog } from "posthog-js/react";
import { NavLink } from "react-router-dom";

type LoginButtonsProps = {
  onLoginWithKakao: () => Promise<AuthError | null>;
  isLoading: boolean;
};

export function LoginButtons({ onLoginWithKakao, isLoading }: LoginButtonsProps) {
  const posthog = usePostHog();

  return (
    <>
      <Button
        size="lg"
        fullWidth
        variant="default"
        radius="xl"
        onClick={onLoginWithKakao}
        loading={isLoading}
      >
        카카오 로그인
      </Button>
      <Button
        component={NavLink}
        onClick={() => posthog.capture("login_with_email")}
        to="/login/email"
        size="lg"
        fullWidth
        variant="default"
        radius="xl"
        loading={isLoading}
      >
        이메일 로그인
      </Button>
    </>
  );
}
